/**
 * BlackStrap Zendesk facade.
 *
 * Uses a delegated document listener so the launcher keeps working if an app
 * or accessibility tool replaces the original button node after page load.
 */
(() => {
  if (window.__bsZendeskFacadeBound) return;
  window.__bsZendeskFacadeBound = true;

  const SCRIPT_ID = 'ze-snippet';
  const SCRIPT_URL = 'https://static.zdassets.com/ekr/snippet.js?key=ca2180ef-57aa-4f9d-bc95-63372f69fc8a';
  let loading = false;

  function facadeButtons() {
    return document.querySelectorAll('#bs-chat-facade');
  }

  function resetFacade() {
    loading = false;
    for (const button of facadeButtons()) {
      button.classList.remove('is-loading');
    }
  }

  function removeFacade() {
    for (const button of facadeButtons()) {
      button.remove();
    }
  }

  function openWidget(tries = 0) {
    if (typeof window.zE === 'function') {
      try {
        window.zE('messenger', 'open');
        removeFacade();
        return;
      } catch (error) {
        try {
          window.zE('webWidget', 'open');
          removeFacade();
          return;
        } catch (legacyError) {
          // Zendesk may still be initializing; retry below.
        }
      }
    }

    if (tries < 49) {
      window.setTimeout(() => openWidget(tries + 1), 150);
    } else {
      resetFacade();
    }
  }

  function loadWidget() {
    const existingScript = document.getElementById(SCRIPT_ID);
    if (existingScript) {
      openWidget();
      return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = SCRIPT_URL;
    script.onload = () => openWidget();
    script.onerror = () => {
      script.remove();
      resetFacade();
    };
    document.body.appendChild(script);
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target instanceof Element
        ? event.target.closest('#bs-chat-facade')
        : null;

      if (!button || loading) return;

      loading = true;
      button.classList.add('is-loading');
      loadWidget();
    },
    true
  );
})();
